import { Utils } from '../../app.base'
import { MsgBox, Vue, Routes } from '../../app.vues';

import SwbBoundDevcSpecificAcc from './BoundDevcSpecificAcc'
Vue.regist(SwbBoundDevcSpecificAcc);

export function boundDevcDlog(params, callback) {
    //
    let selectComId = params.selectComId;
    let comLevel = params.comLevel;
    let includeSubComs = Utils.isTrue(params.includeSubComs) ? true : false;
    let theDlg = Vue.$showDialog({
        title: "关联配件",
        width: 900,
        height: 800,
        template: '<swb-boud-devc :includeSubComs="includeSubComs" :selectComId="selectComId" :comLevel="comLevel" ref="swb_boud_devc"></swb-boud-devc>',
        data: {
            selectComId:selectComId,
            comLevel:comLevel,
            includeSubComs:includeSubComs
        },
        okClicked: function () {
            let result = this.$refs.swb_boud_devc.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbShareAccSpecificAccSelect from './ShareAccSpecificAccSelect'
Vue.regist(SwbShareAccSpecificAccSelect);

export function selectSpecificAccDlog(params, callback) {
    let selectIds = params.selectIds || [];
    let selectComId = params.selectComId;
    //
    let theDlg = Vue.$showDialog({
        title: "关联配件",
        width: 900,
        height: 800,
        template: '<swb-share-acc-specific-acc-list :selectComId="selectComId" :selectIds="selectIds" ref="swb_share_acc_specific_acc_list"></swb-share-acc-specific-acc-list>',
        data: {
            selectComId: selectComId,
            selectIds: selectIds
        },
        okClicked: function () {
            let result = this.$refs.swb_share_acc_specific_acc_list.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbSpecificAccRecList from './SpecificAccRecList'
Vue.regist(SwbSpecificAccRecList);

export function selectSpecificAccRecDlog(params, callback) {
    let accId = params.accId;
    let vendorSn = params.vendorSn;
    let boundDevcId = params.boundDevcId;
    //
    let theDlg = Vue.$showDialog({
        title: "个体配件记录",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-specific-acc-rec-list :vendorSn="vendorSn" :accId="accId" :boundDevcId="boundDevcId" ref="swb_specific_acc_rec_list"></swb-specific-acc-rec-list>',
        data: {
            accId: accId,
            vendorSn: vendorSn,
            boundDevcId: boundDevcId,
        },
        okClicked: function () {
        }
    });
}


import SwbSpecificAccSelect from './SpecificAccSelect'
Vue.regist(SwbSpecificAccSelect);

export function selectSpecificAccSelectDlog(params, callback) {
    let filter = params.filter || {};
    let checkBox = params.checkBox;
    let selectIds = params.selectIds || [];
    //
    let theDlg = Vue.$showDialog({
        title: "个体配件 - 选择",
        width: 900,
        height: 800,
        template: '<swb-specific-acc-list-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" ref="swb_specific_acc_list_select"></swb-specific-acc-list-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds,
        },
        okClicked: function () {
            let result = this.$refs.swb_specific_acc_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
                return true;
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/accStock/selectDlg.js
// module id = 254
// module chunks = 0